export default "__VITE_ASSET__33f330e8__"